var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardTopBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 426,
    height: 425,
    viewBox: "0 0 426 425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "card_top-box",
    d: "M32,0H394a32,32,0,0,1,32,32V425a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V32A32,32,0,0,1,32,0Z",
    fill: "#c5c5c5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTopBox);
export default __webpack_public_path__ + "static/media/card_top-box.c38c331d2c77912fda823a8926679a4a.svg";
export { ForwardRef as ReactComponent };